import {
  grantsFreeMagnets, grantsFreeItem, freeAddonsOf, freeItemLabel, freeItemNoun,
} from '../../utils/offerPricing';
import { formatDeadline } from '../../utils/offerDeadline';

// What a package card shows for the free-magnets tier (issue #5218 items 7 and
// 9). Pure functions: every surface asks grantsFreeMagnets (the ONE
// interpreter) through these, so the badge, the checklist row, the magnet slot
// and the a-la-carte label appear and vanish together with the offer.

export const FREE_MAGNETS_BADGE = '+2 FREE MAGNETS';

// The badge text, or null when the tier is not live.
export const freeMagnetsBadge = (offer) => (grantsFreeMagnets(offer) ? FREE_MAGNETS_BADGE : null);

// The checklist row appended under the option's own contents:
// "(2) FREE Photo Magnets — offer ends Friday, October 24". Null when not live.
export function freeMagnetsRow(offer) {
  if (!grantsFreeMagnets(offer)) return null;
  const deadline = formatDeadline(offer.expiresOn);
  return `(2) FREE Photo Magnets${deadline ? ` — offer ends ${deadline}` : ''}`;
}

// The a-la-carte "Magnets" option on the pricelist (778 has one at $14.95;
// 877 needs one added in admin). Matched by name, the same way the checklist
// parser recognises a magnet row.
export const isMagnetsOption = (option) => /magnet/i.test(option?.name || '');

// The label that replaces the Magnets option's tagline while the tier is live.
export const magnetsOptionLabel = (option, offer) => (
  grantsFreeMagnets(offer) && isMagnetsOption(option) ? 'FREE with any package' : null
);

// ---- Free item of your choice (#5747) ---------------------------------------
//
// What a package card shows while a FREE_ADDON_CHOICE offer is live. Same
// shape as the magnet tier's three above, keyed off grantsFreeItem (the ONE
// interpreter), so badge, row and thumbnail appear and vanish together.

// The ribbon: "+ FREE MAGNET" -- the set's category noun, because the full
// label can run five words and a ribbon has room for one.
export const freeItemBadge = (offer) => (grantsFreeItem(offer) ? `+ FREE ${freeItemNoun(offer).toUpperCase()}` : null);

// The checklist row appended under the option's own contents:
// "Includes a FREE dry erase magnet with package". Just that (Katie,
// 2026-10-18): no design count and no deadline here -- the banner above the
// cards carries the deadline, and the picker is where the designs are.
// Null when not live.
export function freeItemRow(offer) {
  if (!grantsFreeItem(offer)) return null;
  return `Includes a FREE ${freeItemLabel(offer)} with package`;
}

// The small picture beside that row: the first add-on in the set that has
// product art, with what THAT item sells for ("$29.95 value", Katie
// 2026-10-18) -- the pictured item's price, so the picture and the number
// never disagree. Null when none has art (the row still says it in words);
// `value` null when the item has no price to quote.
export function freeItemThumbnail(offer) {
  if (!grantsFreeItem(offer)) return null;
  const addon = freeAddonsOf(offer).find((a) => a?.imageUrl && !a.imageUrl.includes('missing'));
  if (!addon) return null;
  const price = Number(addon.priceWith);
  return { src: addon.imageUrl, alt: addon.name || '', value: price > 0 ? price : null };
}
